import React from 'react';

import styles from './beneficiaryEvent.module.css';

interface IBeneficiaryEvent {
  benNumber: string;
  benName: string;
}

const BeneficiaryClick = ({ benNumber, benName }: IBeneficiaryEvent) => (
  <div className={styles.container}>
    <div className={styles.benNumber}>{benNumber}</div>
    <div className={styles.benName}>{benName}</div>
  </div>
);

export default BeneficiaryClick;
